import {Element} from './element';
import {Folder} from './folder';
import {Field} from './field';
import {Group} from './group';

export class Kit {

  // cannot put as public in constructor due to ts-lint error
  public = null;
  public rootLevelElements;

  constructor(
              public id: number,
              public name: string,
              public description: string,
              public thumbnail: string,
              public thumbnail_relative: string,
              public video_preview: string,
              public video_preview_relative: string,
              public banner: string,
              public banner_relative: string,
              public ord: number,
              public isPublic: number,
              public isFeatured: number,
              public style_id: number,
              public resolution_id: number,
              public frame_rate_id: number,
              public code: string,
              public elements: Element[],
              public style: {
                id: number,
                name: string,
                created_at: string,
                updated_at: string
              },
              public resolution: {
                id: number,
                name: string,
                created_at: string,
                updated_at: string
              },
              public frame_rate: {
                id: number,
                rate: number,
                created_at: string,
                updated_at: string
              },
              public fields: Field[],
              public groups: Group[] = [],
              public folders: Folder[] = [],
              public updated_at: string,
              public created_at: string
  ) {
    this.public = isPublic;
    this.rootLevelElements = elements.filter((element: Element) => element.folder_id === null);
  }

}


// WEBPACK FOOTER //
// ./src/app/services/kit.ts